<mat-list *ngIf="clientAddresses$">

    <mat-list-item *ngFor="let add of clientAddresses$" class="rad-bord clicked address-card-height" [class.isSelected]="delivryAddress$ && delivryAddress$.address_id === add.address_id || billingAddress$ && billingAddress$.address_id === add.address_id"
        (click)="selectAddress(add)">

        <!-- <mat-icon  fxHide.xs mat-list-icon class="great-ico" *ngIf="delivryAddress$ && delivryAddress$.address_id === add.address_id || billingAddress$ && billingAddress$.address_id === add.address_id">done</mat-icon> -->

        <div mat-line>

            <div fxLayout="column">

                <div fxLayout="row" fxLayoutAlign="start center"> <span class="mat-subheading-1 boldest">{{add.name}}</span></div>

                <div fxLayout="row" fxLayoutGap="10px">

                    <div>
                        <span class="mat-subheading-1">{{add.address | descFilter: 60}}</span>
                    </div>

                    <div fxHide.xs>
                        <span class="mat-subheading-1">{{add.city_name | uppercase}}</span>
                    </div>

                    <div fxHide.xs>
                        <span class="mat-subheading-1">-</span>
                    </div>

                    <div fxHide.xs>
                        <span class="mat-subheading-1">{{add.postal}}</span>
                    </div>

                </div>

                <div fxLayout="row">
                    <div *ngIf="add.comment" fxLayoutAlign="start center">
                        <span class="mat-caption" style="font-style: italic;">{{add.comment}}</span>
                    </div>
                </div>

            </div>

        </div>

        <mat-icon mat-icon-button class="great-ico" (click)="openDialAddress(add); $event.stopPropagation();" angulartics2On="click" angularticsAction="openUpdateDialog" angularticsCategory="addresses">edite</mat-icon>
        <mat-icon mat-icon-button class="dark-ico" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">more_vert</mat-icon>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openDialDeletAddress(add.address_id); $event.stopPropagation();" angulartics2On="click" angularticsAction="openDeleteDialog" angularticsCategory="addresses">{{"basket.delete" | translate}}</button>
        </mat-menu>

        <mat-divider></mat-divider>

    </mat-list-item>

</mat-list>

<div *ngIf="clientAddresses$" fxLayout="row" fxLayoutAlign="end center" [ngStyle]="{'margin-top' : clientAddresses$.length > 0 ? '10px' : '0px'}">

    <button mat-stroked-button (click)="openDialAddress()" angulartics2On="click" angularticsAction="openCreateDialog" angularticsCategory="addresses">
      {{"dialogs.addresses.add-address" | translate | uppercase}}
  </button>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'AddressAllincComponent.loader'|translate" [type]="'line'">
</app-popup-loader>